import { useQueries } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useSlider from "../../hooks/useSlider";
import Sidebar from "../sidebar/Sidebar";
import "./../../admin/Usermanagement/addNewUser.css";
import {
  getItemPreparedReports,
  getReports,
  getWasteTrackingReports,
} from "../../services/services";
import moment from "moment";
import { constant } from "../../utils/constants";
import CompanyDropDown from "../../components/CompanyDropDown";
import Pagination from "../../utils/Pagination";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getMonthName } from "../../utils/common";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: false,
    title: {
      display: true,
      text: "Total Revenue",
    },
  },
};


const Reportsindex = () => {
  const isSlider = useSlider();
  const [company, setCompany] = useState("");
  const [wastePage, setWastePage] = useState(constant.PAGE_ONE);
  const [wasteLimit, setWasteLimit] = useState(constant.PER_PAGE_TEN);
  const [preparedPage, setPreparedPage] = useState(constant.PAGE_ONE);
  const [preparedLimit, setPreparedLimit] = useState(constant.PER_PAGE_TEN);

  useEffect(() => {
    setWastePage(constant.PAGE_ONE);
    setPreparedPage(constant.PAGE_ONE);
  }, [company?.value, company?.domain]);

  let transactionParams = {
    page: constant.PAGE_ONE,
    limit: constant.PER_PAGE_TEN,
  };
  const queryResults = useQueries({
    queries: [
      {
        queryKey: ["transactions", company?.value],
        queryFn: async () => {
          const resp =
            company?.value &&
            (await getReports({
              ...transactionParams,
              groupBy: "month",
              companyId: company?.value,
            }));
          return resp?.data?.data ?? [];
        },
      },
      {
        queryKey: ["waste-tracking-report", company?.domain, wastePage, wasteLimit],
        queryFn: async () => {
          const resp =
            company?.domain &&
            (await getWasteTrackingReports(company?.domain, {
              page: wastePage,
              limit: wasteLimit,
            }));
          return resp?.data?.data ?? {};
        },
        enabled: !!company?.domain,
      },
      {
        queryKey: [
          "item-prepared-report",
          company?.domain,
          preparedPage,
          preparedLimit,
        ],
        queryFn: async () => {
          const resp =
            company?.domain &&
            (await getItemPreparedReports(company?.domain, {
              page: preparedPage,
              limit: preparedLimit,
            }));
          return resp?.data?.data ?? {};
        },
        enabled: !!company?.domain,
      },
    ],
  });

  const [reports, wasteTrackingReport, itemPreparedReport] = queryResults;
  const wasteTrackingData = wasteTrackingReport?.data ?? {};
  const itemPreparedData = itemPreparedReport?.data ?? {};
  const wasteTrackingList = wasteTrackingData?.trackingList ?? [];
  const itemPreparedList = itemPreparedData?.printers ?? [];
 
  const data = {  
    labels: reports?.data?.analytics?.map((i) => getMonthName(i?.month)),
    datasets: [
      {
        data: reports?.data?.analytics?.map((i) => i?.totalRevenue),
        backgroundColor: "#3a883a",
      },
    ],
  };


  // console.log('data :>> ', data);
  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <div className="d-flex align-items-baseline justify-content-between ">
          <h2 className="mainhead font-24">Reports & Analytics</h2>
          <CompanyDropDown setCompany={setCompany} company={company} />
        </div>
        <Row className="mb-3">
          <div className="d-flex align-items-baseline justify-content-between ">
            <label className="font-18 colorDark pb-3">Transactions</label>
            <p className="mb-0 text-end ">
              <Link
                className="text-decoration-none linktext"
                to="../transactions"
              >
                View All
              </Link>
            </p>
          </div>
          <Col className="tableOuter" xl={8}>
            <div className="table-responsive tableOut">
              <table className="table tableDashboard">
                <thead className="thead-dark">
                  <tr>
                    <th>Order ID</th>
                    <th>User Name</th>
                    <th>Amount</th>
                    <th>Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {reports?.data?.transactions?.transactions &&
                  reports?.data?.transactions?.transactions?.length > 0 ? (
                    reports?.data?.transactions?.transactions?.map(
                      (item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item?.orderId}</td>
                            <td>{item?.userDetails?.userInfo?.name}</td>
                            <td>${item?.amount}</td>
                            <td>{moment(item?.createdAt).format("lll")}</td>
                            <td>
                              <p
                                className={
                                  item?.status ==
                                  constant?.TRANSACTION_STATUS?.SUCCESS
                                    ? "greenBox"
                                    : item?.status ==
                                      constant?.TRANSACTION_STATUS?.PENDING
                                    ? "greenBox yellowBox"
                                    : "greenBox redBox"
                                }
                              >
                                {item?.status ==
                                constant?.TRANSACTION_STATUS?.SUCCESS
                                  ? "Completed"
                                  : item?.status ==
                                    constant?.TRANSACTION_STATUS?.PENDING
                                  ? "Pending"
                                  : "Cancelled"}
                              </p>
                            </td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center">
                        No Transaction Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Col>
          <Col xl={4}>
            <Bar options={options} data={data} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col className="tableOuter" xl={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <label className="font-18 colorDark pb-3">
                Product Waste Tracking
              </label>
              {/* <p className="mb-0 text-end ">
                <Link className="text-decoration-none linktext">View All</Link>
              </p> */}
            </div>
            <div className="table-responsive tableOut">
              <table className="table tableDashboard">
                <thead className="thead-dark">
                  <tr>
                    <th>Item Name</th>
                    <th>Product Quantity</th>
                    <th>Product Wasted</th>
                    <th>Cost of Good</th>
                    <th>Unit of Measure</th>
                    <th>Net Weight</th>
                  </tr>
                </thead>

                <tbody>
                  {wasteTrackingList?.length > 0 ? (
                    wasteTrackingList?.map((item, index) => {
                      const costOfGood = (
                        (item?.wasted ?? 0) *
                        (item?.itemDetails?.wasteTracking?.costOfGoods ?? 0)
                      ).toString();

                      return (
                        <tr key={index}>
                          <td>
                            {item?.itemDetails?.en_name ??
                              item?.itemName ??
                              item?.name ??
                              "--"}
                          </td>
                          <td>{item?.quantity ?? "--"}</td>
                          <td>{item?.wasted ?? 0}</td>
                          <td>{costOfGood}</td>
                          <td>
                            {item?.measureUnit ??
                              item?.itemDetails?.wasteTracking?.measureUnit ??
                              item?.unitOfMeasure ??
                              item?.unit ??
                              item?.measurementUnit ??
                              "--"}
                          </td>
                          <td>{item?.netWeight ?? "--"}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">
                        No Product Waste Tracking Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              page={wastePage}
              setPage={setWastePage}
              limit={wasteLimit}
              setLimit={setWasteLimit}
              totalPages={wasteTrackingData?.total_pages ?? 1}
              total={wasteTrackingData?.total ?? 0}
              length={wasteTrackingList?.length}
            />
          </Col>
        </Row>
        <Row>
          <Col className="tableOuter" xl={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <label className="font-18 colorDark pb-3">Item Prepared</label>
              {/* <p className="mb-0 text-end ">
                <Link className="text-decoration-none linktext">View All</Link>
              </p> */}
            </div>
            <div className="table-responsive tableOut">
              <table className="table tableDashboard">
                <thead className="thead-dark">
                  <tr>
                    <th>Item Name</th>
                    <th>User or Employee</th>
                    <th>Location</th>
                    <th>Quantity of Labels Printed</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {itemPreparedList?.length > 0 ? (
                    itemPreparedList?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item?.itemName ?? "--"}</td>
                          <td>
                            {item?.userDetails?.[0]?.userInfo?.name ??
                              item?.employeeName ??
                              "--"}
                          </td>
                          <td>
                            {item?.locationDetails?.[0]?.name ??
                              item?.locationName ??
                              "--"}
                          </td>
                          <td>{item?.labelQnt ?? "--"}</td>
                          <td>
                            {item?.preparedOn
                              ? moment(item?.preparedOn).format("lll")
                              : item?.createdAt
                                ? moment(item?.createdAt).format("lll")
                                : "--"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center">
                        No Item Prepared Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              page={preparedPage}
              setPage={setPreparedPage}
              limit={preparedLimit}
              setLimit={setPreparedLimit}
              totalPages={itemPreparedData?.total_pages ?? 1}
              total={itemPreparedData?.total ?? 0}
              length={itemPreparedList?.length}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Reportsindex;
